import { notify } from '../../../components/Notifier';
import { usePlatform } from '../../../providers/PlatformProvider/PlatformProvider';
import { Settings } from '../../../providers/SettingsProvider/SettingsProvider';
import { fetcher, logError } from '../../../utils/api/api';
import { GOOGLE_LOGIN_ERROR } from '../../../utils/error-messages';
import { useStoreItem } from '../../use-store';

interface UseGoogleSignInData {
  googleLoginEnabled?: Settings['googleLoginEnabled'];
}

export const useGoogleSignIn = ({
  googleLoginEnabled,
}: UseGoogleSignInData): (() => Promise<void>) => {
  const [role] = useStoreItem('dpCurrentRole');
  const { track } = usePlatform();

  return async () => {
    if (!googleLoginEnabled) {
      return;
    }

    try {
      const { url } = await fetcher<{ url: string }>(
        `composite/public/google/redirect?userType=${role === 'teacher' ? 'staff' : 'student'}`,
        {},
        () => {
          track('error-message-shown', { errorMessage: GOOGLE_LOGIN_ERROR });
          notify.warning(GOOGLE_LOGIN_ERROR);
        },
      );

      if (url) {
        window.location.assign(url);
      }
    } catch (e: unknown) {
      logError(e as string);
      notify.warning(GOOGLE_LOGIN_ERROR);
    }
  };
};

export default useGoogleSignIn;
